import React from 'react';
import { Box, InputAdornment } from '@mui/material';
import { ExtensionSlot } from '../../modules/core/public';
import { CurrencyTextField } from '../../modules/core/public';
import SimulationResultSummary from './SimulationResultSummary';

export function PriceSimulatorSlotAdornment({ slotId, context }) {
  if (!slotId || !context) return null;

  return (
    <InputAdornment position="end" sx={{ ml: 0, maxHeight: 32 }}>
      <ExtensionSlot slotId={slotId} context={context} />
    </InputAdornment>
  );
}

export function PriceSimulatorSavedSummary({ savedSimulation, quantity = 1, compact = true, stacked = false }) {
  if (!savedSimulation?.result) return null;

  return (
    <SimulationResultSummary
      result={savedSimulation.result}
      quantity={quantity}
      compact={compact}
      stacked={stacked}
    />
  );
}

export default function PriceWithSimulatorField({
  slotId,
  simulatorContext = null,
  showSimulator = true,
  showSummary = true,
  summaryCompact = true,
  summarySx = null,
  readOnly = false,
  ...currencyFieldProps
}) {
  const savedSimulation = simulatorContext?.savedSimulation;
  const quantity = simulatorContext?.quantity ?? 1;
  const canApplySimulator = showSimulator && !readOnly && Boolean(simulatorContext?.onApplySimulatedPrice);
  const showAdornment = canApplySimulator || Boolean(savedSimulation);
  const adornmentContext = simulatorContext
    ? { ...simulatorContext, savedSimulation, showTrigger: canApplySimulator }
    : savedSimulation
      ? { savedSimulation, showTrigger: false, quantity }
      : null;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', minWidth: 0 }}>
      <CurrencyTextField
        {...currencyFieldProps}
        disabled={currencyFieldProps.disabled || readOnly}
        InputProps={{
          ...currencyFieldProps.InputProps,
          endAdornment:
            showAdornment && adornmentContext ? (
              <PriceSimulatorSlotAdornment slotId={slotId} context={adornmentContext} />
            ) : (
              currencyFieldProps.InputProps?.endAdornment ?? null
            ),
        }}
      />
      {showSummary && savedSimulation?.result ? (
        <Box sx={{ mt: 0.75, ...summarySx }}>
          <PriceSimulatorSavedSummary
            savedSimulation={savedSimulation}
            quantity={quantity}
            compact={summaryCompact}
          />
        </Box>
      ) : null}
    </Box>
  );
}
